/* SAVE RECENT PRODUCT */

if (window.location.pathname.includes('/products/')) {

  let productHandle = window.location.pathname.split('/products/')[1];

  let recentProducts = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

  recentProducts = recentProducts.filter(item => item !== productHandle);

  recentProducts.unshift(productHandle);

  recentProducts = recentProducts.slice(0, 20);

  localStorage.setItem('recentlyViewed', JSON.stringify(recentProducts));
}


/* SHOW RECENT PRODUCTS */

document.addEventListener("DOMContentLoaded", async () => {

  const container = document.getElementById("recently-viewed-products");

  if (!container) return;

  let recentProducts = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

  recentProducts = recentProducts.slice(1);

  for (const handle of recentProducts) {

    try {

      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();

      let comparePrice = '';

if(product.compare_at_price > product.price){
  comparePrice = `
    <span class="recent-compare-price">
      ₹ ${(product.compare_at_price / 100).toFixed(2)}
    </span>
  `;
}

container.innerHTML += `
  <a href="/products/${product.handle}" class="recent-product-card">
    
    <div class="recent-product-image">
      <img src="${product.featured_image}" alt="${product.title}">
    </div>

    <div class="recent-product-info">
      <p>${product.title}</p>

      <div class="recent-price-wrap">

  ${comparePrice}

  ${
    product.compare_at_price > product.price
    ?

    `<span class="recent-sale-price">
     ₹ ${(product.price / 100).toLocaleString('en-IN', {
  minimumFractionDigits: 2
})}
    </span>`

    :

    `<span class="recent-normal-price">
     ₹ ${(product.compare_at_price / 100).toLocaleString('en-IN', {
  minimumFractionDigits: 2
})}
    </span>`
  }

</div>
    </div>

  </a>
`;

    } catch (e) {
      console.log(e);
    }
  }

});